import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock, FaPaperPlane } from "react-icons/fa";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    product: "Tin Ingots",
    message: ""
  });

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="page-wrapper">
      {/* PAGE BANNER */}
      <section className="page-banner">
        <div className="page-banner-container">
          <h1>Contact Us</h1>
          <p>Get in Touch with JK Metal &amp; Alloys Sales &amp; Technical Support Team</p>
        </div>
      </section>

      {/* MAIN CONTACT CONTENT */}
      <section className="contact-section">
        <div className="container">
          <div className="grid-contact-layout">
            
            {/* CONTACT DETAILS COLUMN */}
            <div className="contact-info-column">
              <span className="sub-title">Connect With Us</span>
              <h2>Contact Information</h2>
              <p className="lead-text">
                Whether you need a product quotation, chemical spec analysis, or bulk pan-India order details, our team in Ahmedabad is here to assist you.
              </p>

              <div className="contact-detail-cards">
                <div className="detail-card">
                  <div className="detail-icon"><FaMapMarkerAlt /></div>
                  <div>
                    <h3>Office &amp; Works Address</h3>
                    <p>
                      Shop 18, 1st Floor, Mahesh Tenement, Nr. Holi Child School,<br />
                      Opp. Hirawadi BRTS Bus Stop, Thakkarbapa Nagar, Bapunagar,<br />
                      Ahmedabad - 382350, Gujarat, India
                    </p>
                  </div>
                </div>

                <div className="detail-card">
                  <div className="detail-icon"><FaPhoneAlt /></div>
                  <div>
                    <h3>Phone Numbers</h3>
                    <p>
                      <a href="tel:+918511698600">+91 85116 98600</a><br />
                      <a href="tel:+918511696999">+91 85116 96999</a>
                    </p>
                  </div>
                </div>

                <div className="detail-card">
                  <div className="detail-icon"><FaEnvelope /></div>
                  <div>
                    <h3>Email Inquiries</h3>
                    <p>
                      <a href="mailto:jkmetal801@gmail.com">jkmetal801@gmail.com</a>
                    </p>
                  </div>
                </div>

                <div className="detail-card">
                  <div className="detail-icon"><FaClock /></div>
                  <div>
                    <h3>Business Hours</h3>
                    <p>Monday — Saturday: 9:00 AM – 5:00 PM<br />Sunday: Closed</p>
                  </div>
                </div>
              </div>
            </div>

            {/* CONTACT FORM COLUMN */}
            <div className="contact-form-column">
              <div className="form-card-wrapper">
                <h2>Send Us A Message</h2>
                <p>Fill out the form below and our sales manager will reply within 24 hours.</p>

                {submitted ? (
                  <div className="form-success-msg">
                    <h3>✓ Thank You!</h3>
                    <p>Your message has been received. Our team will contact you shortly.</p>
                    <button className="btn-gold-sm" onClick={() => setSubmitted(false)}>Send Another Message</button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="contact-form">
                    <div className="form-group">
                      <label>Your Full Name *</label>
                      <input 
                        type="text" 
                        required 
                        placeholder="Enter your name"
                        value={formData.name}
                        onChange={(e) => setFormData({...formData, name: e.target.value})}
                      />
                    </div>

                    <div className="form-row-2">
                      <div className="form-group">
                        <label>Phone Number *</label>
                        <input 
                          type="tel" 
                          required 
                          placeholder="Mobile number"
                          value={formData.phone}
                          onChange={(e) => setFormData({...formData, phone: e.target.value})}
                        />
                      </div>
                      <div className="form-group">
                        <label>Email Address *</label>
                        <input 
                          type="email" 
                          required 
                          placeholder="Your email address"
                          value={formData.email}
                          onChange={(e) => setFormData({...formData, email: e.target.value})}
                        />
                      </div>
                    </div>

                    <div className="form-row-2">
                      <div className="form-group">
                        <label>Company / Business Name</label>
                        <input 
                          type="text" 
                          placeholder="Company name"
                          value={formData.company}
                          onChange={(e) => setFormData({...formData, company: e.target.value})}
                        />
                      </div>
                      <div className="form-group">
                        <label>Product Interest</label>
                        <select 
                          value={formData.product}
                          onChange={(e) => setFormData({...formData, product: e.target.value})}
                        >
                          <option value="Tin Ingots">Tin Ingots</option>
                          <option value="Lead Ingots">Lead Ingots</option>
                          <option value="Solder Wire">Solder Wire</option>
                          <option value="Solder Stick 63/37">Solder Stick (63/37)</option>
                          <option value="Star Solder Stick">Star Solder Stick</option>
                          <option value="Small / Long Solder Ingot">Small / Long Solder Ingot</option>
                          <option value="Copper Axe / Bars">Copper Axe / Bars</option>
                          <option value="Other Metal Alloy">Other Metal Alloy</option>
                        </select>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Message / Requirements *</label>
                      <textarea 
                        rows="4" 
                        required
                        placeholder="Specify estimated quantity, delivery city, or required alloy purity..."
                        value={formData.message}
                        onChange={(e) => setFormData({...formData, message: e.target.value})}
                      ></textarea>
                    </div>

                    <button type="submit" className="btn-gold-submit">
                      <FaPaperPlane style={{ marginRight: '8px' }} /> Submit Message
                    </button>
                  </form>
                )}
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;